import React from "react";

interface ClockIconProps {
    className?: string;
    color?: string;
    size?: "sm" | "md" | "lg" | "xl";
}

export const ClockIcon = ({
    className = "",
    color = "currentColor",
    size = "lg",
}: ClockIconProps) => {
    const sizeClasses = {
        sm: "w-4 h-4",   // ~16x16px
        md: "w-6 h-6",   // ~24x24px
        lg: "w-8 h-8",   // ~32x32px
        xl: "w-10 h-10", // ~40x40px
    };

    return (
        <div className="icon clock-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                className={`${sizeClasses[size]} ${className}`}
                aria-hidden="true"
            >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 6v6l-4 2" />
            </svg>
        </div>
    );
};

export default ClockIcon;